import * as api from '@/api/give-course/other'
import * as TYPES from './type';

export default {
  //授课班级小组
  async getSKGroupList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKGroupList(paramets)
    commit(TYPES.SK_GROUP_LIST, { result })
    cb && cb()
  },
  //授课班级小组学生
  async getSKGroupStuList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKGroupStuList(paramets)
    commit(TYPES.SK_GROUP_STU_LIST, { result })
    cb && cb()
  },
  //授课课堂得分增加
  async postSKScoreStu({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKScoreStu(paramets)
    commit(TYPES.SK_SCORE_STU, { result })
    cb && cb()
  },
  //授课课堂全部学生
  async getSKClassStuList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKClassStuList(paramets)
    commit(TYPES.SK_CLASS_STU_LIST, { result })
    cb && cb()
  },
  //授课课堂得分选项列表
  async getSKOptList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKOptList(paramets)
    commit(TYPES.SK_SCORE_OPT_LIST, { result })
    cb && cb()
  },
  //授课班级获取目录
  async getSKCatalogList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKCatalogList(paramets)
    commit(TYPES.SK_CATALOG_LIST, { result })
    cb && cb()
  },
  //授课课中活动记录
  async postSKActivityRecordAdd({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKActivityRecordAdd(paramets)
    commit(TYPES.SK_ACTIVITY_RECORD_ADD, { result })
    cb && cb()
  },
}



// WEBPACK FOOTER //
// ./src/store/give-course/other/actions.js